// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  width: 100%;
  box-sizing: border-box;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
  padding-left: 2em;
  width: auto;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    width: 1.7em;
    height: 4em;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 10vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
  padding: 20px;
  box-sizing: border-box;
}

.App-link {
  color: #61dafb;
  text-decoration: none;
  transition: color 0.3s ease;
}

.App-link:hover {
  color: #21a1f1;
}

/* Screen */
@media only screen and (min-width: 1024px) {
  .filter-select {
    padding-left: 15%;
    padding-right: 15%;
    width: 70%;
    max-width: 500px;
    margin: 0 auto;
  }

  .button-to-top {
    position: fixed;
    font-size: 1.2em;
    bottom: 30px;
    right: 30px;
    background-color: #61dafb;
    color: white;
    border: none;
    border-radius: 5px;
    padding: 10px 20px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  .button-to-top:hover {
    background-color: #21a1f1;
  }

  .img-technique {
    padding-bottom: 3em;
    width: 90%;
    max-height: 432px;
    margin: 0 auto;
    display: block;
  }
}

/* Phone */
@media screen and (max-width: 1020px) {
  .filter-select {
    width: 90%;
    padding-left: 10%;
    padding-right: 0%;
  }

  .button-to-top {
    position: fixed;
    font-size: 2em;
    bottom: 10%;
    right: 5%;
    background-color: #61dafb;
    color: white;
    border: none;
    border-radius: 5px;
    padding: 10px 15px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  .button-to-top:hover {
    background-color: #21a1f1;
  }

  .img-technique {
    padding-bottom: 3em;
    width: 90%;
    max-height: 432px;
    margin: 0 auto;
    display: block;
  }
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,WAAW;AACX;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,cAAc;IACd,cAAc;EAChB;AACF;;AAEA,UAAU;AACV;EACE;IACE,UAAU;IACV,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,WAAW;IACX,SAAS;IACT,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,cAAc;IACd,cAAc;EAChB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".App {\n  text-align: center;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n  padding-left: 2em;\n  width: auto;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    width: 1.7em;\n    height: 4em;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 10vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n.App-link {\n  color: #61dafb;\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\n.App-link:hover {\n  color: #21a1f1;\n}\n\n/* Screen */\n@media only screen and (min-width: 1024px) {\n  .filter-select {\n    padding-left: 15%;\n    padding-right: 15%;\n    width: 70%;\n    max-width: 500px;\n    margin: 0 auto;\n  }\n\n  .button-to-top {\n    position: fixed;\n    font-size: 1.2em;\n    bottom: 30px;\n    right: 30px;\n    background-color: #61dafb;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    padding: 10px 20px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n  }\n\n  .button-to-top:hover {\n    background-color: #21a1f1;\n  }\n\n  .img-technique {\n    padding-bottom: 3em;\n    width: 90%;\n    max-height: 432px;\n    margin: 0 auto;\n    display: block;\n  }\n}\n\n/* Phone */\n@media screen and (max-width: 1020px) {\n  .filter-select {\n    width: 90%;\n    padding-left: 10%;\n    padding-right: 0%;\n  }\n\n  .button-to-top {\n    position: fixed;\n    font-size: 2em;\n    bottom: 10%;\n    right: 5%;\n    background-color: #61dafb;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    padding: 10px 15px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n  }\n\n  .button-to-top:hover {\n    background-color: #21a1f1;\n  }\n\n  .img-technique {\n    padding-bottom: 3em;\n    width: 90%;\n    max-height: 432px;\n    margin: 0 auto;\n    display: block;\n  }\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
